import Vue from "vue";

export default {
    bind(el, binding, vnode) {
        const {type, event, info} = binding.value
        if (type === 'input') {
            el = getInputEl(el)
        }

		const zType = type === 'input' ? 'change' : type
        el.addEventListener(zType, (e) => {
            let timeout;
            if (!timeout) {
                timeout = setTimeout(() => {
                    timeout = null;
                    handleTrackEvent({
                        eventType: type, event: event, element: el, info: info
                    }, e)
                }, 500)
            }
        })
    }
}

function getInputEl(el) {
    if (el.tagName === 'INPUT') {
        return el
    } else {
        for (let i = 0; i < el.childNodes.length; i++) {
            const child = el.childNodes[i]
            if (child.tagName === 'INPUT') {
                return child
            } else {
                const input = getInputEl(child)
                if (input) {
                    return input
                }
            }
        }
    }
}


function handleTrackEvent(data, originalEvent) {
    const {eventType, event, info} = data
    let eventData = {
        label: event,
        value: originalEvent.target._value || originalEvent.target.innerText || '',
        timestamp: Date.now(),
        info: info,
        pageUrl: Vue.prototype.$monitoAction.monitoInit.dataProcess.newPageUrl || '',
        linkUrl: window.location.href || '',
    }
    const trackData = {
        eventType, eventData
    }
    Vue.prototype.$monitoAction.track(trackData)
}

export const showLoading = () => {
    let eventData = {
        label: "进入页面",
        value: '',
        timestamp: Date.now(),
        info: '',
        pageUrl: Vue.prototype.$monitoAction.monitoInit.dataProcess.newPageUrl || '',
        linkUrl: window.location.href || '',
    }
    const trackData = {
         eventData
    }
    trackData.eventType = 'page'
    Vue.prototype.$monitoAction.track(trackData)
}
